import React, { createRef, memo, useCallback, useEffect } from "react";
import { Persona, Scene } from "@soulmachines/smwebsdk";
import { PersonaVideoContainer } from "./PersonaVideoStyles";
import ProxyVideo from "../ProxyVideo/ProxyVideo";

const PersonaVideo: React.FC<{
  dispatch: Function;
  scene: Scene | null;
  videoPlaying: boolean;
  tabletLandscape: boolean;
  persona: Persona | null;
}> = memo(({ dispatch, scene, videoPlaying, tabletLandscape, persona }) => {
  const videoRef = createRef<HTMLVideoElement>();
  const containerRef = createRef<HTMLDivElement>();

  // On component Mount
  useEffect(() => {
    if (scene) {
      // User must be connected already in order to startVideo.
      scene
        .startVideo()
        .then((videoState: any) => {
          if (videoState.audio) {
            console.log("video is playing with audio");
          } else {
            console.log(
              "video is playing, but muted. user interaction required."
            );
            dispatch({
              type: "SET_ERROR",
              payload: { errorType: "userInteraction" },
            });
          }
          persona?.conversationSend("welcome", {}, {});

          dispatch({
            type: "START_VIDEO",
          });
        })
        .catch((error: Error) => console.log("could not start video:", error));
      // When this component unmounts, We disconnect the scene
      return () => {
        dispatch({
          type: "DISCONNECT",
        });
        scene.disconnect();
      };
    }
  }, [dispatch, scene, persona]);

  const handleResize = useCallback(() => {
    if (containerRef.current) {
      // the video should resize with the element size.
      // this needs to be done through the context store because the Persona server
      // needs to be aware of the video target dimensions to render a propperly sized video
      const videoHeight = containerRef.current.clientHeight;
      const videoWidth = containerRef.current.clientWidth;

      dispatch({
        type: "SET_VIDEO_DIMENSIONS",
        payload: {
          videoHeight,
          videoWidth,
        },
      });
    }
  }, [containerRef, dispatch, tabletLandscape]);

  /**
   * Transfering srcObject from ProxyVideo to videoRef
   */
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = ProxyVideo.srcObject;
    }
  }, [videoPlaying, videoRef]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    // when component dismounts, remove resize listener
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return (
    <PersonaVideoContainer ref={containerRef}>
      <video id="dp-video" ref={videoRef} autoPlay playsInline data-sm-video />
    </PersonaVideoContainer>
  );
});

export default PersonaVideo;
